import {createOne} from "./Api";

const MODULE = 'report';


export function createReport(data) {
	return createOne(MODULE, data);
}
